import { INBOX_BRIDGE_DOMAIN } from "@launchos/shared-utils/env";

export type InboxAccess = { ok: true; url: string } | { ok: false; message: string };

// LI-4/5 — trade the Launch OS login for a one-time Launch Inbox login link. Each link works
// once, so ask again for every new frame or tab.
export const inboxAccess = async (token: string): Promise<InboxAccess> => {
  try {
    const resp = await fetch(`${INBOX_BRIDGE_DOMAIN}/sso`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    const body = await resp.json().catch(() => ({}));
    if (resp.ok && body.url) return { ok: true, url: body.url };
    return { ok: false, message: body.error || "Launch Inbox couldn't open. Try again in a minute." };
  } catch {
    return { ok: false, message: "Couldn't reach Launch Inbox. Check your connection and try again." };
  }
};
